const resourceTypes = [
  "MYYNTIPALVELU",
  "ASIAKASPALVELU",
  "MUU"
];

export default resourceTypes;
